
import React, { useCallback, useMemo, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";

import { Grid, useTheme } from "@mui/material";
// import UpdateProjectBacklog from "./UpdateProjectBacklog";
// import CommonErrorMessage from "../../../../common/error-message/CommonErrorMessage";
// import "../../../../common/tab/tabstyles.css";
import ChrUserDetailsView from "./ChrUserDetails";
import MappingAccounts from "./mapping_Accounts/MappingAccounts"
import AddMappingAccount from "./mapping_Accounts/AddMappingAccounts"
import TabHeader from "../../../components/common/TabHeader";



// ----------------------------------------------------------------------------------------------------------------------------------------------------------------
const ViewBacklogs = ({ fromProject360, ...props }) => {
  const [showEdit, setShowEdit] = useState(false);
  const [fromBacklog, setFromBacklog] = useState(false);
  const [details, setDetails] = useState([]);
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [viewMore, setViewMore] = useState(true);
  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const projectInfo = useSelector((state) => state?.projectInfo);
  // let detailsData = projectInfo?.projectInfoDetails;
  // const checkHandlingCode = useMemo(
  //   () => detailsData[0]?.handling_method_data?.handlingCode ?? "",
  //   [detailsData]
  // );
  // useEffect(() => {
  //   try {
  //     dispatch(
  //       getProjectBacklogDetailsForBacklog({
  //         id: Boolean(props?.selectedData?.id)
  //           ? props?.selectedData?.id
  //           : props?.projectBacklog?.selectedData?.id,
  //       })
  //     );
  //   } catch (err) {
  //     console.log(err);
  //   }
  //   dispatch(getBacklogStatus());

  //   window.scrollTo(0, 0);
  //   return () => {
  //     dispatch(resetBacklogDetailsForBacklog());
  //   };
  // }, []);


  // useEffect(() => {
  //   try {
  //     setDetails(props?.projectBacklog?.projectBacklogDataDetailsForBacklog);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [props?.projectBacklog?.projectBacklogDataDetailsForBacklog]);

  let shrink = props.sidebar ? "scale" : "no-scale";

  // const [componentListTab4, setComponentListTab4] = useState([

  //   {
  //     component: <TestSuites height={{ height: "70vh" }} />,
  //   },
  //   { component: <TestCases height={{ height: "70vh" }} /> },
  //   { component: <TestSteps height={{ height: "70vh" }} /> },
  //   { component: <Defects /> },
  // ]);
  // customUseEffect(() => {
  //   if (checkHandlingCode === "SD") {
  //     setComponentListTab4([{ component: <Defects viewMoreInitial={true} /> }]);
  //   }
  // }, []);

  // const tabsData = useMemo(() => {
  //   return [
  //     {
  //       components: [{ component: <Tab1 /> }],
  //     },
  //     checkHandlingCode !== "SD" && {
  //       components: [{ component: <Tab2 /> }],
  //       display: checkHandlingCode !== "SD",
  //     },
  //     {
  //       components: [{ component: <Tab3 /> }],
  //     },
  //     {
  //       components: [{ component: <Tab4 componentList={componentListTab4} /> }],
  //     },
  //     {
  //       components: [{ component: <Tab5 /> }],
  //     },
  //     {
  //       components: [{ component: <Tab6 /> }],
  //     },
  //     {
  //       components: [{ component: <Tab7 /> }],
  //     },
  //   ].filter(Boolean);
  // }, [details]);

  // const tabsHeadingData = [
  //   { name: "Overview", customWidth: "10rem" },
  //   checkHandlingCode !== "SD" && {
  //     name: "Specifications",
  //     display: checkHandlingCode !== "SD",
  //     customWidth: "10rem",
  //   },
  //   {
  //     name: "Execution",
  //     customWidth: "10rem",
  //   },
  //   {
  //     name: "Quality",
  //     customWidth: "10rem",
  //   },
  //   {
  //     name: "Delivery",
  //     customWidth: "10rem",
  //   },
  //   {
  //     name: "Comments",
  //     customWidth: "10rem",
  //   },
  //   {
  //     name: "Attachments",
  //     customWidth: "10rem",
  //   },
  // ].filter(Boolean);

  console.log(props?.val)

  try {
    return (
      <>

        <Grid spacing={1} container>
          <Grid item md={12} lg={12} xl={12} xs={12} sm={12}>
            <ChrUserDetailsView
              val={props?.val}
              props={props}
              details={details}
              openEdit={() => {
                setShowEdit(true);
                setFromBacklog(true);
              }}
              closeEdit={() => setShowEdit(true)}
              forViewDetails={props?.forViewDetails}
              close={props?.close}
              setValue={props.setValue}
            />
          </Grid>

          <Grid item md={12} lg={12} xl={12} xs={12} sm={12}>
            <TabHeader
              headerName="Account Mapping"
              // createPermission={checkApiPermissionWithAuth(
              //   props?.auth,
              //   "Project360.Backlog.linkedBacklogCreate"
              // )}
              handleNew={() => setShowAdd(true)}
              viewMore={viewMore}
              setViewMore={setViewMore}

            />
            {viewMore &&
              <MappingAccounts />}
          </Grid>

          {
            showAdd && < AddMappingAccount showAdd={showAdd} close={() => setShowAdd(false)} />
          }



          {/* <Grid item md={12} lg={12} xl={12} xs={12} sm={12} mt={1}>
            <div>
              <TabsLayout
                backgroundColor=""
                customWidth="13rem"
                value={value}
                handleChange={handleChange}
                tabNames={tabsHeadingData}
                matchingValue={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9]}
                tabIndicatorProps={true}
                scrollButton={false}
              />
              <TabPanelLayout
                background={false}
                value={value}
                index={0}
                tabsData={tabsData}
              />
            </div>
          </Grid> */}
        </Grid>
        {/* {showEdit && (
          <UpdateProjectBacklog
            showEdit={showEdit}
            selectedData={details?.length > 0 ? details[0] : []}
            close={() => {
              setShowEdit(false);
              setFromBacklog(false);
            }}
            fromBacklog={fromBacklog}
            standardsDriven={checkHandlingCode === "SD"}
            administrativeFocused={checkHandlingCode === "AF"}
            technoFunctional={
              !(checkHandlingCode === "AF") && !(checkHandlingCode === "SD")
            }
            backlogTypeFilter={
              fromProject360 === "Defect"
                ? "Defect"
                : fromProject360
                  ? "Change Request"
                  : ""
            }
          />
        )} */}
      </>
    );
  } catch (err) {
    // console.log(err);
    // return <CommonErrorMessage />;
  }
};

const mapStateToProps = (state) => ({
  projectBacklog: state.projectBacklog,
  linkingForTask: state.linkingForTask,
  linkFeatureDetailToBacklog: state.linkFeatureDetailToBacklog,
  linkedRequirements: state.linkedRequirements,
  linkFeatureScenarioToBacklog: state.linkFeatureScenarioToBacklog,
  myProject: state.myProject,
  linkScenariosToBacklog: state.linkScenariosToBacklog,
  linkedBacklogToTask: state.linkedBacklogToTask,
  backlogTask: state.backlogTask,
  backlogAttachments: state.backlogAttachments,
  assignedToPeople: state.assignedToPeople,
  linkRiskToBacklog: state.linkRiskToBacklog,
  featureSpecifications: state.featureSpecifications,
  functionalScenarios: state.functionalScenarios,
  risk: state.risk,
  backlogMember: state.backlogMember,
});

export default connect(mapStateToProps, {})(ViewBacklogs);
